import { useQuery } from "@tanstack/react-query";

import type { operations } from "@/lib/api/schema";

import { getCertificationsList } from "./api";
import { certificationsKeys } from "./key";

/**
 * 資格一覧取得用のhook
 */
export function useCertificationsQuery(
  params: operations["PersonCertificationController_getPersonCertifications_v2"]["parameters"],
) {
  return useQuery({
    queryKey: certificationsKeys.list(params),
    queryFn: () => getCertificationsList(params),
  });
}
